<template>
  <tr class="">
    <td class="col-6 mt-5">
      <div class="w-100">
        <Select2 container-class="form-group" :multiple="true" :show-search="true"
          :selectClass="'form-control form-control-solid form-select form-select-solid rounded-end-0 border-start'"
          :name="`purchase-fees-${index}`" :isRequired="true" :placeholderText="$t('purchase.products')"
          v-model="feeData.id" :IsInputGroup="true" icon="bi bi-plus" :clickAddon="openFeeModal">
          <option v-for="(fee, index) in fees" :key="index" :value="fee.id">{{ fee.title }}</option>
        </Select2>
      </div>
    </td>
    <td class="col-4">
      <div class="">
        <input class="form-control form-control-solid fw-bolder" v-model="feeData.price" type="number" min="0">
      </div>
    </td>
    <td class="col-1">
      <a class="btn btn-sm btn-icon btn-bg-light btn-active-color-danger py-3" @click.prevent="deleteRow(index)">
        <i class="bi bi-trash-fill fs-5"></i>
      </a>
    </td>
  </tr>
  <div class="modal fade" tabindex="-1" :id="'kt_modal_new_purchase_fee'">
    <div class="modal-dialog">
      <FeeForm @after-created="afterCreateFee" />
    </div>
  </div>
</template>

<script setup>

import Input from "@/components/Input.vue";
import Select2 from "@/components/Select2.vue";
import { computed, ref } from "vue";
import FeeForm from "@/components/Fee/FeeForm.vue";
import { useStore } from "vuex";

const store = useStore()
const props = defineProps({
  fee: { type: Object, default: { id: [], price: 0 } },
  index: Number
})
const emits = defineEmits(['deleteFee'])

const fees = computed(() => store.getters['fees/getFees'])

const feeData = ref(props.fee)

function openFeeModal() {
  $("#kt_modal_new_purchase_fee").modal('toggle')
}
function afterCreateFee(fee) {
  $("#kt_modal_new_purchase_fee").modal('toggle')
  feeData.value.id.push(fee.id)
}

function deleteRow(index) {
  emits('deleteFee', index)
}

</script>

<style scoped></style>